import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Hardware} from '../../types/hardware';
import {Router} from '@angular/router';
import {base64Encode} from '@softline/core';
import {CommonModule} from '@angular/common';
import {DynamicModule} from '@softline/dynamic';
import {ReactiveFormsModule} from '@angular/forms';
import {
  BetriebssystemInputComponent
} from '../../components/inputs/betriebssystem-input/betriebssystem-input.component';
import {GarantietypInputComponent} from '../../components/inputs/garantietyp-input/garantietyp-input.component';
import {HerstellerInputComponent} from '../../components/inputs/hersteller-input/hersteller-input.component';
import {ProduktInputComponent} from '../../components/inputs/produkt-input/produkt-input.component';
import {SubnetzmaskeInputComponent} from '../../components/inputs/subnetzmaske-input/subnetzmaske-input.component';
import {SupporttypInputComponent} from '../../components/inputs/supporttyp-input/supporttyp-input.component';
import {TypInputComponent} from '../../components/inputs/typ-input/typ-input.component';
import {HardwareFormDirective} from '../../directives/hardware-form.directive';
import {BackNavigable, BackNavigationService} from '@softline/application';
import { Observable } from 'rxjs';
import {
  KtostammStandortInputComponent
} from "../../components/inputs/ktostamm-standort-input/ktostamm-standort-input.component";

import { DateInputComponent } from '@softline/ui-core/date-input';
import { InputComponent } from '@softline/ui-core';
import { ToggleSwitchComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-search',
    imports: [CommonModule, DynamicModule, ReactiveFormsModule,
        BetriebssystemInputComponent, GarantietypInputComponent, HerstellerInputComponent,
        ProduktInputComponent, SubnetzmaskeInputComponent, SupporttypInputComponent,
        TypInputComponent, HardwareFormDirective, KtostammStandortInputComponent,
    DateInputComponent,
    InputComponent,
    ToggleSwitchComponent,
    TranslatePipe],
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit, OnDestroy, BackNavigable {

  constructor(private router: Router, private backNavigationService: BackNavigationService) {
  }

  ngOnInit(): void {
    this.backNavigationService.set(this);
  }

  ngOnDestroy(): void {
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/hardware-management']);
  }

  async search(value: Partial<Hardware>): Promise<void> {
    console.log('search: ', value);
    const nonNullProps = Object
      .entries(value)
      .filter(([_, val]) => !!val)
      .map(([key, val]) => ({ [key]: val }))
      .reduce((obj, currentVal) => ({ ...obj, ...currentVal }), {} as Partial<Hardware>);

    const query = base64Encode(JSON.stringify(nonNullProps));
    await this.router.navigate(['hardware-management'], { queryParams: { query } });
  }

}
